module.exports = __webpack_public_path__ + "img/vyberte_byt.06ebe86d.svg";